"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.number.constructor");
var _enroll = require("@/api/activity/enroll");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EnrollJoinPane',
  components: {
    Pagination: _Pagination.default,
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    activityId: {
      type: Number,
      required: true
    },
    activityTitle: {
      type: String,
      default: ''
    },
    initFilters: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      downloadLoading: false,
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      // 自定义报名字段标签（取活动配置，空则显示默认名）
      inputLabels: ['自定义输入标题1', '自定义输入标题2', '自定义输入标题3'],
      // 状态: 1-待开奖, 2-已中奖, 3-未中奖, 5-已领取
      statusMap: {
        1: '待开奖',
        2: '已中奖',
        3: '未中奖',
        5: '已领取'
      },
      statusOptions: [{
        value: 1,
        label: '待开奖'
      }, {
        value: 2,
        label: '已中奖'
      }, {
        value: 3,
        label: '未中奖'
      }, {
        value: 5,
        label: '已领取'
      }],
      statusTagType: {
        1: 'info',
        2: 'success',
        3: 'info',
        5: 'success'
      },
      listQuery: {
        page: 1,
        limit: 20,
        enrollId: this.activityId,
        status: null,
        userId: null
      }
    };
  },
  created: function created() {
    this.loadInputLabels();
    if (this.initFilters) {
      this.applyFilters(this.initFilters);
    } else {
      this.fetchData();
    }
  },
  methods: {
    // 活动配置的自定义报名字段标签作为列头
    loadInputLabels: function loadInputLabels() {
      var _this = this;
      (0, _enroll.getEnrollDetail)(this.activityId).then(function (response) {
        var data = response.data || {};
        _this.inputLabels = [data.input1 || '自定义输入标题1', data.input2 || '自定义输入标题2', data.input3 || '自定义输入标题3'];
      }).catch(function () {});
    },
    // 应用筛选条件（报名数据点击跳转 / 已打开的列表切换条件）
    // status: 1-待开奖, 2-已中奖, 3-未中奖, 5-已领取
    applyFilters: function applyFilters(filters) {
      if (!filters) {
        this.fetchData();
        return;
      }
      this.listQuery.page = 1;
      this.listQuery.status = filters.status != null ? filters.status : null;
      this.listQuery.userId = filters.userId || null;
      this.fetchData();
    },
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) return userpic;
      return this.imgPath + userpic;
    },
    fetchData: function fetchData() {
      var _this2 = this;
      this.listLoading = true;
      var query = _objectSpread({}, this.listQuery);
      if (query.status === '' || query.status === undefined || query.status === null) delete query.status;
      if (!query.userId) delete query.userId;
      (0, _enroll.getEnrollJoinPage)(query).then(function (response) {
        _this2.list = response.records || [];
        _this2.total = response.total || 0;
        _this2.listLoading = false;
      }).catch(function (error) {
        console.error('获取报名明细失败:', error);
        _this2.listLoading = false;
        _this2.list = [];
        _this2.total = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    handleExport: function handleExport() {
      var _this3 = this;
      this.downloadLoading = true;
      var query = _objectSpread({}, this.listQuery);
      delete query.page;
      delete query.limit;
      if (query.status === '' || query.status === undefined || query.status === null) delete query.status;
      if (!query.userId) delete query.userId;
      (0, _enroll.exportEnrollJoin)(query).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "\u62A5\u540D\u8BB0\u5F55-".concat(_this3.activityTitle || _this3.activityId, ".xlsx");
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this3.downloadLoading = false;
      });
    }
  }
};